// Last-resort recovery: unregister every Service Worker, wipe every cache,
// then hard-reload with a cache-buster. Used by:
//   - the version-pin hook (when the server tells us this client is stale)
//   - the inline blank-screen self-heal (in index.html)
//   - any admin / debug button that needs a clean slate
//
// Returns a Promise that resolves once the reload is in flight. Callers
// don't usually need to await — the page is about to be replaced anyway.

export async function forceFlushAndReload(reason = "manual") {
  const jobs = [];
  try {
    if ("serviceWorker" in navigator) {
      jobs.push(
        navigator.serviceWorker.getRegistrations().then((regs) =>
          Promise.all(regs.map((r) => r.unregister().catch(() => {}))),
        ).catch(() => {}),
      );
    }
    if (typeof caches !== "undefined") {
      jobs.push(
        caches.keys().then((keys) =>
          Promise.all(keys.map((k) => caches.delete(k).catch(() => {}))),
        ).catch(() => {}),
      );
    }
  } catch { /* extension-blocked storage APIs etc — proceed to reload anyway */ }

  await Promise.race([
    Promise.all(jobs),
    new Promise((res) => window.setTimeout(res, 2000)), // hard 2 s safety net
  ]);

  const sep = window.location.href.indexOf("?") >= 0 ? "&" : "?";
  const url = window.location.href.split("#")[0] + sep + "_sv_flush=" + Date.now();
  // Log so admins inspecting DevTools can see why the reload fired.
  console.info("[ShubhVivah] force-flush reload —", reason);
  window.location.replace(url);
}
